import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";
import VisibilityIcon from "@material-ui/icons/Visibility";
import InactiveOrgModal from "./DashboardModalWidget/InactiveOrgModal";
import ActiveOrgModal from "./DashboardModalWidget/ActiveOrgModal";
import ProposalOrgModal from "./DashboardModalWidget/ProposalOrgModal";

export function OrganizationCountsWidget({ org_counts, loading }) {
  const [show, setShow] = useState(false);
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [showProposalOrgModal, setShowProposalOrgModal] = useState(false);

  return (
    <>
      <InactiveOrgModal closeModal={() => setShow(false)} show={show} />
      <ActiveOrgModal
        closeModal={() => setShowActiveModal(false)}
        show={showActiveModal}
      />
      <ProposalOrgModal
        closeModal={() => setShowProposalOrgModal(false)}
        show={showProposalOrgModal}
      />
      <div className="mt-5 row">
        <div className="col-lg-12 row m-0 p-0">
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}}>
              <CardBody>
                <h3 className="h3">Total Lembaga</h3>
                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">{+org_counts.all_count || 0}</div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}}>
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Lembaga Aktif</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => setShowActiveModal(!show)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">{+org_counts.active_count || 0}</div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}} >
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Ajuan</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => setShowProposalOrgModal(!show)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">
                    {+org_counts.registration_count || 0}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12">
            <Card style={{height: '150px'}}>
              <CardBody>
                <div
                  className="
                d-flex
                justify-content-between 
                align-items-center
              "
                >
                  <h4 className="h4">Lembaga Non Aktif</h4>
                  <OverlayTrigger
                    overlay={
                      <Tooltip id="products-edit-tooltip">Lihat Detail</Tooltip>
                    }
                  >
                    <a
                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-1"
                      onClick={() => setShow(!show)}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary">
                        <VisibilityIcon />
                      </span>
                    </a>
                  </OverlayTrigger>
                </div>

                <div className="d-flex justify-content-end">
                  <div className="h1 m-5">
                    {+org_counts.inactive_count || 0}
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
